import get from "lodash.get";
import moment from "moment";
import Vue from "vue";

const state = {
  carePackages: {
    /**
     * pathfinderId: {
     *  count: 0,
     *  next: 1000000,
     * }
     */
  }
};

const mutations = {
  NEXT_CARE_PACKAGE(state, pathfinderId) {
    const carePackage = get(state.carePackages, pathfinderId, {
      count: -1,
      next: 0
    });

    carePackage.count++;

    const now = moment();
    const next = moment(now).add(2, "minutes");
    carePackage.next = moment(next);

    Vue.set(state.carePackages, pathfinderId, carePackage);
  },

  LOG_TIME_TO_CARE_PACKAGE(state, { pathfinder, timeOff }) {
    if (state.carePackages[pathfinder.id]) {
      const carePackage = state.carePackages[pathfinder.id];
      if (carePackage.next <= 0) return 0;

      const diff = carePackage.next - timeOff;
      carePackage.next = diff < 0 ? 0 : diff;
    }
  }
};

const getters = {
  nextCarePackageTime(state, getters, rootState) {
    if (
      rootState.pathfinders.pathfinder &&
      state.carePackages[rootState.pathfinders.pathfinder.id]
    ) {
      return state.carePackages[rootState.pathfinders.pathfinder.id].next;
    }
  }
};

const actions = {
  newCarePackage({ commit }, pathfinder) {
    commit("NEXT_CARE_PACKAGE", pathfinder.id);
  },

  deployCarePackage({ commit }, pathfinder) {
    commit("NEXT_CARE_PACKAGE", pathfinder.id);
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 1000 * 3);
    });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
